import { bool, string } from 'prop-types';
import Head from 'next/head';
import React, { Fragment } from 'react';
import { SITE_KEY } from 'constants/site';
import styles from './styles';

const API_URL = `${process.env.API_URI}/api/email-subscriptions`;
const SUBSCRIBE_URI = `${API_URL}/manage-subscriptions/${SITE_KEY}`;

function AmpEmailSignup({ title, description, isActive, listKey, optInEvent }) {
  return (
    <Fragment>
      <Head>
        <script
          async
          key="amp-form"
          custom-element="amp-form"
          src="https://cdn.ampproject.org/v0/amp-form-0.1.js"
        />
        <script
          async
          key="amp-mustache"
          custom-template="amp-mustache"
          src="https://cdn.ampproject.org/v0/amp-mustache-0.2.js"
        />
      </Head>
      <section className="AmpEmailSignup__body">
        {title && <h2 className="AmpEmailSignup__title">{title}</h2>}
        {description && <p className="AmpEmailSignup__desc">{description}</p>}
      </section>
      <section className="AmpEmailSignup__form">
        {isActive ? (
          <form method="post" action-xhr={SUBSCRIBE_URI} target="_top">
            <fieldset>
              <label
                className="AmpEmailSignup__label"
                htmlFor="email-signup-email"
              >
                <input
                  className="AmpEmailSignup__email-input"
                  id="email-signup-email"
                  type="email"
                  name="email"
                  required
                />
                <span className="AmpEmailSignup__label-name">
                  Email Address
                </span>
              </label>
              <input
                type="hidden"
                name="email_list_keys"
                value={JSON.stringify([listKey])}
              />
              <input type="hidden" name="opt_event" value={optInEvent} />
              <input type="submit" value="Subscribe" />
              <div submitting="">
                <template type="amp-mustache">
                  {/* prettier-ignore */}
                  <p>Subscribing...</p>
                </template>
              </div>
              <div submit-success="">
                <template type="amp-mustache">
                  {/* prettier-ignore */}
                  <p>Thank You!</p>
                </template>
              </div>
              <div submit-error="">
                <template type="amp-mustache">
                  {/* prettier-ignore */}
                  <p>Sorry, there seems to be an issue submitting your subscription request. Try again later.</p>
                </template>
              </div>
            </fieldset>
          </form>
        ) : (
          <div className="AmpEmailSignup__no-list">
            <h4>Sorry, this list is no longer accepting subscriptions.</h4>
            {/* prettier-ignore */}
            <p>Feel free to <a href="/email">subscribe to our other emails</a>.</p>
          </div>
        )}
      </section>
      <style jsx>{styles}</style>
    </Fragment>
  );
}

AmpEmailSignup.defaultProps = {
  title: undefined,
  description: undefined,
  optInEvent: '',
  isActive: true
};

AmpEmailSignup.propTypes = {
  title: string,
  description: string,
  listKey: string.isRequired,
  optInEvent: string,
  isActive: bool
};

export default AmpEmailSignup;
